import axios from '../utils/axios';

export default function fetchNTCPremiumJobRejectionTags(adminId, params) {
    return axios.get(`/admin/${adminId}/ntc-premium-jobs/rejection-tags`, { params })
        .then(res => res.data)
        .catch(err => err);
}
